import React, { useState,useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import * as Styled from "./styled";
import list from "../../images/list.svg";
import clock from "../../images/clocks.svg";
import calendar from "../../images/calender.svg";
import view from "../../images/view.svg";
import copylink from "../../images/copylink.svg";
import adduser from "../../images/adduser.svg";
import copyLinkWhite from "../../images/copylink_white.svg";
import addUserWhite from "../../images/adduser_white.svg";
import viewWhite from "../../images/view_white.svg";
import InviteeModal from "./InviteeModal";
import Header from "../../components/header";
import moment from "moment";
import {  message } from 'antd';


const SecondStep = ({data,open,setOpen}) => {
    const [isHoveredView, setIsHoveredView] = useState(false);
    const [isHoveredLink, setIsHoveredLink] = useState(false);
    const [isHoveredAdd, setIsHoveredAdd] = useState(false);
    const [ind, setInd] = useState();

    const [id ,setId]=useState('')

    const showModal = () => {
        setOpen(true);
      };

      const copyClipBoard = async ({ link }) => {
       await navigator.clipboard.writeText(link);
       message.success("Link copied successfully");
      };
    const navigate=useNavigate()

    const handleMouseOverView = (index) => {
        setIsHoveredView(true);
        setInd(index);
    };
    const handleMouseOutView = (index) => {
        setIsHoveredView(false);
        setInd(index);
        setInd(index);
    };
    const handleMouseOverLink = (index) => {
        setIsHoveredLink(true);
        setInd(index);
    };
    const handleMouseOutLink = (index) => {
        setIsHoveredLink(false);
        setInd(index);
    };
    const handleMouseOverAdd = (index) => {
        setIsHoveredAdd(true);
        setInd(index);
        setInd(index);
    };
    const handleMouseOutAdd = (index) => {
        setIsHoveredAdd(false);
        setInd(index);
    };

    useEffect(()=>{

    },[data])

console.log(open,'RRRRRRR')

console.log(id,'IDDD')


    return (
        <Styled.SecondStep>
            <Header/>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',margin:'0 30px',marginTop:'40px'}}>
            <Styled.Heading>AI Machine Interviews</Styled.Heading>
            <button onClick={()=>navigate('/ai-interview-form')} style={{width:'100px',height:'40px',backgroundColor:'white',border:'2px solid #1B49EA',borderRadius:'8px',color:'#1B49EA'}} > Add New</button>
            </div>

            <Styled.Wrapper>
                <div>
                    <Styled.Div1>Assessments Details</Styled.Div1>
                    <Styled.Div2>Invites</Styled.Div2>
                    <Styled.Div3>Attempts</Styled.Div3>
                    <Styled.Div4 heading={true}>Completed</Styled.Div4>
                    <Styled.Div5>Actions</Styled.Div5>
                </div>
                {data?.map((x,index)=>{
                    return(
                        <Styled.ListContainer index={index} key={index}>
                        <Styled.Div1>
                            <span>{x.test_title}</span>
                            <Styled.Icons>
                                <span>
                                    <img alt="" src={list} />
                                  {x.total_questions}
                                </span>
                                <span>
                                    <img alt="" src={clock} />
                                    {Math.floor(x.duration / 60)>0?`${Math.floor(x.duration / 60)}Hr`:''}{' '}
                                    {`${(x.duration % 60)} Min`}

                                </span>
                                <span>
                                    <img alt="" src={calendar} />
                                    {moment(x.start_date).format("DD") +
                                        " " +
                                        moment(x.start_date).format("MMM") +
                                        " " +
                                        moment(x.start_date).format("YY")}
                                </span>
                            </Styled.Icons>
                        </Styled.Div1>
                        <Styled.Div2>{x.no_of_invitees?x.no_of_invitees:"-"}</Styled.Div2>
                        <Styled.Div3>{x.attempted}</Styled.Div3>
                        <Styled.Div4>{x.completed}</Styled.Div4>
                        <Styled.Div5>
                            <span
                                onMouseOver={() => handleMouseOverView(index)}
                                onMouseOut={() => handleMouseOutView(index)}
                                onClick={()=>navigate('/ai-interview-status',{state:{
                                    test_id:x.test_id,
                                     title:x.test_title
                                 }})}
                            >
                                <img

                                    alt=""
                                    src={
                                        ind === index && isHoveredView
                                            ? viewWhite
                                            : view
                                    }
                                />
                            </span>
                            <span
                                onMouseOver={() => handleMouseOverAdd(index)}
                                onMouseOut={() => handleMouseOutAdd(index)}
                                 onClick={()=>{
                                    showModal(true)
                                    setId(x.test_id)} }
                            >
                                <img
                                    alt=""
                                    src={
                                        ind === index && isHoveredAdd
                                            ? addUserWhite
                                            : adduser
                                    }
                                />
                            </span>
                            <span
                                onMouseOver={() => handleMouseOverLink(index)}
                                onMouseOut={() => handleMouseOutLink(index)}
                                onClick={() => {
                                    copyClipBoard({
                                      link:x.url,
                                    });

                                  }}
                            >
                                <img
                                    alt=""
                                    src={
                                        ind === index && isHoveredLink
                                            ? copyLinkWhite
                                            : copylink
                                    }
                                />
                            </span>
                        </Styled.Div5>

                    </Styled.ListContainer>
                    )
                })}
            </Styled.Wrapper>
            {<InviteeModal isOpen={open} setOpen={setOpen} id={id} />}
        </Styled.SecondStep>
    );
};

export default SecondStep;
